import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import Layout from '@/custom/components/templates/Layout'
import SideNav from './SideNav'
import AuthContext from '@/product/context/auth/authContext'
import './Dashboard.css'

const DashboardLayout = (props) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)

    const { user } = authContext
    return (
        <Layout>
            <div className={user?.admin ? 'dashboard seller-dashboard-wrapper ' : 'dashboard '}>
                <div className="">
                    <div className="d-flex justify-content-start dashboard-layout-wrapper">
                        {!props.hideNav ? (
                            <div className="dashboardLt noPrint">
                                <SideNav />
                            </div>
                        ) : (
                            <></>
                        )}
                        <div className={!props.hideNav ? 'dashboardRt' : 'dashboardRt mw-100'}>
                            {/* <div
                                className={`${
                                    user?.admin ? 'seller-title mb-2' : 'maTitle'
                                } d-flex justify-content-between align-items-center w-100`}
                            >
                                {!user?.admin && (
                                    <Button
                                        id="dashboard_back"
                                        onClick={() => {
                                            history.goBack()
                                            window.scrollTo(0, 0)
                                        }}
                                        className="moveBack"
                                    >
                                        <span className="material-icons">keyboard_arrow_left</span>
                                        {'back'}
                                    </Button>
                                )}
                            </div> */}
                            <div className="customContainer">{props.children}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default DashboardLayout
